module.exports = __webpack_public_path__ + "static/media/phone.e2baac61.svg";